import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let MapIcon = (props) => {
  props = Object.assign({viewBox: '0 0 70 70'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M35,61.9l-1.1-1.3c-0.6-0.8-15.8-20-15.8-35.1c0-9.3,7.6-16.9,16.9-16.9c9.3,0,16.9,7.6,16.9,16.9
	c0,15.2-15.2,34.3-15.8,35.1L35,61.9z M35,11.2c-7.8,0-14.1,6.4-14.1,14.2c0,12,10.7,27.4,14.1,32c3.5-4.7,14.1-20.1,14.1-32
	C49.1,17.6,42.8,11.2,35,11.2z M35,34.3c-4.8,0-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7
	C43.7,30.4,39.8,34.3,35,34.3z M35,19.6c-3.3,0-5.9,2.7-5.9,6s2.7,6,5.9,6c3.3,0,5.9-2.7,5.9-6S38.3,19.6,35,19.6z"/>
    </SvgIcon>
  );
};

MapIcon.displayName = 'MapIcon';
MapIcon.muiName = 'SvgIcon';

export default MapIcon;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/icons/Map.Icon.js